var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 804.499,
    height: 321.077,
    viewBox: "0 0 804.499 321.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a {\n\t\t\t\tfill: #f2f2f2;\n\t\t\t}\n\n\t\t\t.b {\n\t\t\t\tfill: #2f2e41;\n\t\t\t}\n\n\t\t\t.c,\n\t\t\t.g {\n\t\t\t\tfill: var(--primary-color);\n\t\t\t}\n\n\t\t\t.d {\n\t\t\t\tfill: none;\n\t\t\t\tstroke: #3f3d56;\n\t\t\t\tstroke-miterlimit: 10;\n\t\t\t}\n\n\t\t\t.e {\n\t\t\t\tfill: #57b894;\n\t\t\t}\n\n\t\t\t.f {\n\t\t\t\tfill: #fff;\n\t\t\t}\n\n\t\t\t.g {\n\t\t\t\topacity: 0.3;\n\t\t\t}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08 -116.264)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 394.874,
    cy: 26.142,
    rx: 394.874,
    ry: 26.142,
    transform: "translate(9.839 385.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M546.357,324.894c-64.336,0-110.528,41.276-110.528,137.587,0,109.152,46.192,138.046,110.528,138.046s113.28-31.645,113.28-138.046C659.637,348.743,610.693,324.894,546.357,324.894Zm.423,239.4c-44.56,0-67.84-26.142-67.84-101.744,0-66.707,24.233-101.885,68.793-101.885s68.793,23.107,68.793,101.885C616.526,536.247,591.34,564.3,546.78,564.3Z",
    transform: "translate(-156.778 -199.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M317.359,528.033h-26.6V449.7a15.687,15.687,0,0,0-15.687-15.687h-6.233A15.687,15.687,0,0,0,253.152,449.7v78.331h-75.03a8.955,8.955,0,0,1-7.918-13.139l79.411-150.3a15.687,15.687,0,0,0-7.172-21.513l-4.688-2.214a15.687,15.687,0,0,0-20.533,6.79L120.37,528.837a21.271,21.271,0,0,0-2.512,10.028h0a21.271,21.271,0,0,0,21.271,21.271H253.152v49.531a18.8,18.8,0,0,0,18.8,18.8h0a18.8,18.8,0,0,0,18.8-18.8V560.136h26.6a16.052,16.052,0,0,0,16.052-16.052h0a16.052,16.052,0,0,0-16.052-16.052Z",
    transform: "translate(-76.833 -203.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M975.356,528.033h-26.6V449.7a15.687,15.687,0,0,0-15.687-15.687h-6.233A15.687,15.687,0,0,0,911.149,449.7v78.331h-75.03a8.955,8.955,0,0,1-7.918-13.139l79.411-150.3a15.687,15.687,0,0,0-7.172-21.513l-4.688-2.214a15.687,15.687,0,0,0-20.533,6.79l-96.852,181.18a21.272,21.272,0,0,0-2.512,10.028h0a21.271,21.271,0,0,0,21.271,21.271H911.149v49.531a18.8,18.8,0,0,0,18.8,18.8h0a18.8,18.8,0,0,0,18.8-18.8V560.136h26.6a16.052,16.052,0,0,0,16.052-16.052h0a16.052,16.052,0,0,0-16.052-16.052Z",
    transform: "translate(-242.268 -203.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M327.162,515.78h-26.6V437.449a15.687,15.687,0,0,0-15.687-15.687h-6.233a15.687,15.687,0,0,0-15.687,15.687V515.78h-75.03a8.955,8.955,0,0,1-7.918-13.139l79.411-150.3a15.687,15.687,0,0,0-7.172-21.513l-4.688-2.214a15.687,15.687,0,0,0-20.533,6.79l-96.852,181.18a21.272,21.272,0,0,0-2.512,10.028h0a21.271,21.271,0,0,0,21.271,21.271H262.955v49.531a18.8,18.8,0,0,0,18.8,18.8h0a18.8,18.8,0,0,0,18.8-18.8V547.883h26.6a16.052,16.052,0,0,0,16.052-16.052h0a16.052,16.052,0,0,0-16.052-16.052Z",
    transform: "translate(-79.298 -200.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M993.736,515.78h-26.6V437.449a15.687,15.687,0,0,0-15.687-15.687h-6.233a15.687,15.687,0,0,0-15.687,15.687V515.78H854.5a8.955,8.955,0,0,1-7.918-13.139l79.411-150.3a15.687,15.687,0,0,0-7.172-21.513l-4.688-2.214A15.687,15.687,0,0,0,893.6,335.4l-96.852,181.18a21.271,21.271,0,0,0-2.512,10.028h0a21.271,21.271,0,0,0,21.271,21.271H929.528v49.531a18.8,18.8,0,0,0,18.8,18.8h0a18.8,18.8,0,0,0,18.8-18.8V547.883h26.6a16.052,16.052,0,0,0,16.052-16.052h0A16.052,16.052,0,0,0,993.736,515.78Z",
    transform: "translate(-246.89 -200.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M565.962,313.866c-64.336,0-110.528,41.276-110.528,137.587,0,109.152,46.192,138.045,110.528,138.045s113.28-31.645,113.28-138.046C679.242,337.715,630.3,313.866,565.962,313.866Zm.423,239.4c-44.56,0-67.84-26.142-67.84-101.744,0-66.707,24.233-101.885,68.793-101.885s68.793,23.107,68.793,101.885c0,73.7-25.186,101.744-69.746,101.744Z",
    transform: "translate(-161.707 -197.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1066.471,567.283a15.58,15.58,0,1,0,2.075-29.88l.39,8.019-3.794-6.872a15.521,15.521,0,0,0-8,8.775,15.277,15.277,0,0,0-.9,4.214A15.577,15.577,0,0,0,1066.471,567.283Z",
    transform: "translate(-312.756 -253.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1094.009,655.791c-1.339-6.82,4.464-12.866,10.2-16.8s12.43-7.791,14.386-14.46c2.811-9.585-5.562-18.362-12.079-25.932a93.79,93.79,0,0,1-12.369-18.383,25.309,25.309,0,0,1-2.959-8.359c-.514-4.249.851-8.476,2.226-12.529q6.871-20.25,14.693-40.161",
    transform: "translate(-321.522 -248.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1067.328,564.525a15.58,15.58,0,1,0,2.075-29.88l.39,8.019L1066,535.792a15.521,15.521,0,0,0-8,8.775,15.282,15.282,0,0,0-.9,4.214A15.577,15.577,0,0,0,1067.328,564.525Z",
    transform: "translate(-312.971 -252.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1092.137,512.026a15.561,15.561,0,0,1,11.214-9.879l1.283,7.623,2.378-8.006a15.578,15.578,0,1,1-14.875,10.263Z",
    transform: "translate(-321.554 -244.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1093.28,508.349a15.562,15.562,0,0,1,11.214-9.879l1.283,7.623,2.378-8.007a15.578,15.578,0,1,1-14.875,10.263Z",
    transform: "translate(-321.841 -243.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1104.6,615.336a15.578,15.578,0,0,0,13.788-27.714l-1.827,6.153-1.3-7.713a.267.267,0,0,0-.04-.015,15.579,15.579,0,1,0-10.625,29.29Z",
    transform: "translate(-322.339 -265.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1105.586,611.612a15.578,15.578,0,0,0,13.788-27.714l-1.827,6.153-1.3-7.713a.266.266,0,0,0-.04-.015,15.579,15.579,0,0,0-10.625,29.29Z",
    transform: "translate(-322.588 -264.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1086.3,653.916a15.571,15.571,0,1,0,3-12.2l6.941,10.448-9.484-5.545a15.435,15.435,0,0,0-.459,7.3Z",
    transform: "translate(-320.261 -278.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1087.155,651.158a15.571,15.571,0,1,0,3-12.2l6.941,10.448-9.484-5.545a15.435,15.435,0,0,0-.459,7.3Z",
    transform: "translate(-320.476 -277.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M69.8,621.464a10.236,10.236,0,1,0,1.363-19.631l.256,5.269-2.493-4.515a10.2,10.2,0,0,0-5.255,5.766,10.039,10.039,0,0,0-.589,2.769A10.234,10.234,0,0,0,69.8,621.464Z",
    transform: "translate(-63.054 -269.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M87.89,679.615c-.88-4.481,2.933-8.453,6.7-11.035s8.167-5.119,9.452-9.5c1.847-6.3-3.654-12.064-7.936-17.038a61.627,61.627,0,0,1-8.127-12.078,16.626,16.626,0,0,1-1.944-5.492c-.338-2.791.559-5.569,1.463-8.232q4.515-13.3,9.654-26.387",
    transform: "translate(-68.813 -266.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M70.36,619.652a10.236,10.236,0,1,0,1.363-19.631l.256,5.269-2.493-4.515a10.2,10.2,0,0,0-5.255,5.766,10.039,10.039,0,0,0-.589,2.769,10.234,10.234,0,0,0,6.717,10.344Z",
    transform: "translate(-63.196 -268.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.66,585.159a10.224,10.224,0,0,1,7.368-6.491l.843,5.009,1.563-5.26a10.235,10.235,0,1,1-9.773,6.743Z",
    transform: "translate(-68.834 -263.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M87.411,582.743a10.224,10.224,0,0,1,7.368-6.491l.843,5.009L97.184,576a10.235,10.235,0,1,1-9.773,6.743Z",
    transform: "translate(-69.023 -263.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M94.845,653.036a10.235,10.235,0,0,0,9.059-18.209l-1.2,4.042-.851-5.068-.026-.01a10.236,10.236,0,0,0-6.981,19.244Z",
    transform: "translate(-69.35 -277.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M95.5,650.589a10.235,10.235,0,0,0,9.059-18.209l-1.2,4.042-.851-5.068-.026-.01A10.236,10.236,0,0,0,95.5,650.589Z",
    transform: "translate(-69.514 -276.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M82.823,678.383a10.231,10.231,0,1,0,1.973-8.016l4.561,6.864-6.231-3.643a10.14,10.14,0,0,0-.3,4.795Z",
    transform: "translate(-67.985 -285.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M83.386,676.571a10.231,10.231,0,1,0,1.973-8.015l4.561,6.864-6.231-3.643a10.14,10.14,0,0,0-.3,4.795Z",
    transform: "translate(-68.126 -285.277)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 12.726,
    cy: 16.469,
    rx: 12.726,
    ry: 16.469,
    transform: "translate(347.299 222.414)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 12.726,
    cy: 16.469,
    rx: 12.726,
    ry: 16.469,
    transform: "translate(416.543 222.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M607.912,537.974c0,7.441-10.39,13.474-23.206,13.474S561.5,545.415,561.5,537.974c0-6.445,7.793-11.835,18.205-13.153a37.492,37.492,0,0,1,5-.322,37.948,37.948,0,0,1,8.332.9C601.736,527.337,607.912,532.24,607.912,537.974Z",
    transform: "translate(-188.375 -250.06)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 12.726,
    cy: 16.469,
    rx: 12.726,
    ry: 16.469,
    transform: "translate(350.294 218.671)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 12.726,
    cy: 16.469,
    rx: 12.726,
    ry: 16.469,
    transform: "translate(419.537 219.045)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 23.206,
    cy: 13.474,
    rx: 23.206,
    ry: 13.474,
    transform: "translate(376.12 270.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M599.222,526.4a3.7,3.7,0,0,1-.988,2.539,3.247,3.247,0,0,1-2.38,1.054h-7.486A3.491,3.491,0,0,1,585,526.4a3.671,3.671,0,0,1,.614-2.052,35.206,35.206,0,0,1,5-.343,35.677,35.677,0,0,1,8.332.958,3.791,3.791,0,0,1,.277,1.437Z",
    transform: "translate(-194.283 -249.934)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.743,
    cy: 3.743,
    r: 3.743,
    transform: "translate(359.277 226.905)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 3.743,
    cy: 3.743,
    r: 3.743,
    transform: "translate(428.894 226.905)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.743,
    cy: 3.743,
    r: 3.743,
    transform: "translate(432.637 262.088)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.743,
    cy: 3.743,
    r: 3.743,
    transform: "translate(341.311 262.088)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5aaebca9.svg";
export { ForwardRef as ReactComponent };